/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Result_Action_Clickup_TaskInputs */



/**
* | output |
* | --- |
* | "Create a ClickUp task" |
*
* @param {Agent_Result_Action_Clickup_TaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_result_action_clickup_task = /** @type {((inputs?: Agent_Result_Action_Clickup_TaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Result_Action_Clickup_TaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("ClickUp-Aufgabe erstellen")
	return /** @type {LocalizedString} */ ("Create a ClickUp task")
});